import { useState } from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import sendAxios from '@lcsc-ui/utils/request';
import Utils from '@lcsc-ui/utils/Utils';
import { Modal, Upload, Input, message, Spin } from 'antd';

import API from '@/apis/index';

// 纠错弹窗
export default function CorrectDialog(props) {
  const { productCode, productId, productName, onClose } = props;
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [correctContent, setCorrectContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [correctionAnnex, setCorrectionAnnex] = useState(null);
  const [fileName, setFileName] = useState('未选择任何文件');

  const { TextArea } = Input;

  const uploadProps = {
    name: 'file',
    action: '',
    accept: '.xls,.doc,.rar,.zip,.txt,.jpg,.jpeg,.png,.gif',
    headers: {
      authorization: 'authorization-text',
    },
    maxCount: 1,
    showUploadList: false,
    beforeUpload: (file) => {
      const allowedMimeTypes = [
        'application/vnd.ms-excel', // .xls
        'application/msword', // .doc
        'application/x-rar-compressed', // .rar
        'application/x-zip-compressed', // .zip
        'text/plain', // .txt
        'image/jpeg',
        'image/png',
        'image/gif', // 图片
      ];
      if (!allowedMimeTypes.includes(file.type)) {
        message.error('附件类型只允许[.xls,.doc,.rar,.zip,.txt,.jpg,.jpeg,.png,.gif]');
        return Upload.LIST_IGNORE;
      }
      return true;
    },
    onChange(info) {
      setCorrectionAnnex(info.file.originFileObj);
      setFileName(info.file.name);
    },
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setCorrectContent('');
    setCorrectionAnnex(null);
    setFileName('未选择任何文件');
    onClose();
  };

  const submitConnection = () => {
    if (!correctContent) {
      message.warning('请先输入您的纠错内容再进行提交。');
      return;
    }
    if (Utils.isXss(correctContent)) {
      message.warning('含非法内容，请修改！');
      return;
    }
    const remark = correctContent;
    const formData = new FormData();
    formData.append('correctionType', '商品描述');
    formData.append('correctionAnnex', correctionAnnex);
    formData.append('productId', productId);
    formData.append('correctContent', remark);
    setLoading(true);
    sendAxios({
      method: 'post',
      baseURL: 'lcscSearchUrl',
      data: formData,
      url: API.insertProductConnection,
      formData: true,
    })
      .then(({ result }) => {
        if (result) {
          const execute_result = result.execute_result;
          const sensitive_word_intercept_tip = result.sensitive_word_intercept_tip;
          if (execute_result) {
            if (execute_result === 'success') {
              message.success('纠错信息提交成功。');
              onClose();
            } else if (execute_result === 'forbid') {
              message.error('提交失败，商品记录不存在。');
            } else if (execute_result === 'ANNEXforbid') {
              message.error('提交失败，您上传的附件太大，不能超过5M。');
            } else if (execute_result === 'ANNEXerror') {
              message.error('提交失败，附件类型只允许[.xls,.doc,.rar,.zip,.txt,.jpg,.jpeg,.png,.gif]。');
            } else if (execute_result === 'ANNEXfail') {
              message.error('提交失败，附件没有上传成功。');
            } else if (execute_result === 'over_limit') {
              message.error('您每天可以提交2次，感谢您的支持！');
            } else if (execute_result === 'sensitive_word_intercept_error') {
              message.error(`${sensitive_word_intercept_tip}`);
            } else {
              message.error('提交失败，请稍候再试。');
            }
          }
        }
        onClose();
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal
      title="资料纠错"
      open={isModalOpen}
      onCancel={handleCancel}
      destroyOnClose={true}
      width={460}
      footer={null}
      maskClosable={false}
      centered
    >
      <Spin indicator={<LoadingOutlined />} size="small" spinning={loading}>
        <p className="text-[#54657D] text-[12px] mt-[16px]">
          如果您发现商品介绍、规格参数、包装清单、商品图片等信息有误或不完善，欢迎指出，感谢您对立创商城的支持。
        </p>
        <ul className="text-[#54657D] text-[14px] mt-[16px]">
          <li>
            <span className="after:content-['：']">商品编号</span>
            <span className="text-[#000000]">{productCode}</span>
          </li>
          <li className="mt-[16px]">
            <span className="after:content-['：']">商品名称</span>
            <span className="text-[#000000]">{productName}</span>
          </li>
          <li className="mt-[16px]">
            <span className="after:content-['：']">上传附件</span>
            <Upload {...uploadProps}>
              <ul className="flex items-center">
                <li>
                  <p className="w-72px h-[24px] lc-flex-center border-[rgba(0,0,0,0.15)] border-[1px] border-solid p-[0_8px] rounded-[4px] cursor-pointer">
                    点击上传
                  </p>
                </li>
                <li className="w-[220px] h-[24px] rounded-[0_8px_8px_0] bg-[#EDF9FF] flex items-center text-[#199FE9]">
                  <span className="ml-[10px] text-ellipsis whitespace-nowrap overflow-hidden text-[12px]">
                    {fileName}
                  </span>
                </li>
              </ul>
            </Upload>
          </li>
          <li className="mt-[16px] flex">
            <span className="after:content-['：']">具体内容</span>
            <TextArea
              placeholder="请填写描述"
              className="flex-1"
              maxLength={200}
              autoSize={{
                minRows: 6,
                maxRows: 6,
              }}
              onChange={(e) => setCorrectContent(e.target.value)}
            />
          </li>
          <li className="text-right mt-[16px]">
            <button
              disabled={loading}
              className="text-[white] bg-[#199FE9] w-[74px] h-[32px] rounded-[6px]"
              onClick={submitConnection}
            >
              提交
            </button>
          </li>
        </ul>
      </Spin>
    </Modal>
  );
}
